import React from 'react';
import { BodyText, HeadingText, v2blue400 } from '@paypalcorp/pp-react';

import styles from './Module.less';
import glamorous from 'glamorous';

const StepText = glamorous(BodyText)({
  '& a': {
    color: v2blue400,
  },
});

export default class extends React.Component {
  render() {
    let content = this.props.desc;
    content = content.replace(/\n|\r\n|\r/, '<br/>');

    return (
      <div className={this.props.info}>
        <div className={this.props.className} id={this.props.id}>
          <HeadingText
            className={styles['text-align-center']}
            as='h3'
            size='md'
          >
            {this.props.title}
          </HeadingText>
          <StepText
            className={styles['paragraph-margin']}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
    );
  }
}
